import { render, staticRenderFns } from "./FiltroTabelaComponent.vue?vue&type=template&id=ab78974c"
import script from "./FiltroTabelaComponent.vue?vue&type=script&lang=js"
export * from "./FiltroTabelaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports